var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"header__breadcrumb"},[_c('div',{staticClass:"container"},[_c('nav',{staticClass:"header__breadcrumb_nav"},[_c('a',{staticClass:"header__dashboard-text",attrs:{"href":""}},[_vm._v(_vm._s(_vm.$t('header.topAccountNav.titles.dashboard')))]),_c('v-icon',{attrs:{"name":"chevron-right"}})],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }